import { DrycutApolloProvider } from '@drycut/apollo';
import { AuthProvider } from '@drycut/auth';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router';

import './styles.css';
import router from './router';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <StrictMode>
    <DrycutApolloProvider>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </DrycutApolloProvider>
  </StrictMode>,
);
